import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withCtx as _withCtx, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "color-butterfly" }
const _hoisted_2 = { class: "container min-h-full m-auto flex flex-col text-center" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h2", { class: "mt-auto mb-0" }, "Color Your Butterfly", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "flex-none uppercase font-bold mb-4" }, " Select a color and tap to fill in wings ", -1)
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" Next ")
const _hoisted_6 = { class: "flex flex-row flex-none" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_butterfly_canvas = _resolveComponent("butterfly-canvas")!
  const _component_color_picker = _resolveComponent("color-picker")!
  const _component_router_link_button = _resolveComponent("router-link-button")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_back_button = _resolveComponent("back-button")!
  const _directive_tap = _resolveDirective("tap")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createVNode(_component_butterfly_canvas, {
        src: _ctx.butterflySrc,
        gradients: _ctx.gradients,
        colors: _ctx.colors,
        fillColor: _ctx.selectedColor,
        onChange: _cache[0] || (_cache[0] = ($event: any) => (_ctx.onChange($event))),
        class: "flex-none mx-8 my-auto"
      }, null, 8, ["src", "gradients", "colors", "fillColor"]),
      _hoisted_4,
      _createVNode(_component_color_picker, {
        gradients: _ctx.gradients,
        colors: _ctx.colors,
        onSelectColor: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onSelectColor($event.color))),
        class: "flex-none mx-auto"
      }, null, 8, ["gradients", "colors"]),
      _createVNode(_component_router_link, {
        to: _ctx.nextRoute,
        custom: ""
      }, {
        default: _withCtx(({ navigate }) => [
          _withDirectives(_createVNode(_component_router_link_button, {
            class: "mx-auto mt-auto",
            disabled: !_ctx.canGoNext
          }, {
            default: _withCtx(() => [
              _hoisted_5
            ]),
            _: 2
          }, 1032, ["disabled"]), [
            [_directive_tap, navigate]
          ])
        ]),
        _: 1
      }, 8, ["to"]),
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_router_link, {
          to: _ctx.prevRoute,
          custom: ""
        }, {
          default: _withCtx(({ navigate }) => [
            _createVNode(_component_back_button, {
              class: "mr-auto",
              onClick: navigate
            }, null, 8, ["onClick"])
          ]),
          _: 1
        }, 8, ["to"])
      ])
    ])
  ]))
}